<script setup>
import { PD_bySerialNumber, PD_byId } from '@/api/workPlace/prescription'
import {
  BASE_LABEL,
  columnWesternMedicine,
  columnChineseMedicine,
  agreementMedicine,
  getStatusImg,
  columnSaleChinese,
  columnSaleAgreement,
  columnSaleWestern,
  columnActive,
  columnOrder,
  CHINESE_DRUG_ADD,
  AGREEMENT_DRUG_ADD,
  EN_Add_Label,
  CN_Add_Label,
  AN_Add_Label,
  NEW_Label
} from './config'
import {
  calcDiagnosis,
  newCalcDiagnosis,
  handleCureStatus,
  handleAssertCureName,
  momentFormat
} from '@/utils/index'
import { defineProps, watch, ref, reactive, defineEmits, onMounted, computed } from 'vue'
import DetermineEffect from '@/components/DetermineEffect'
import { getEntrust, getTitle, getProfileByKey } from '@/utils/index'
import { isPlanOrVisitMethods } from '@/hooks/globalApi'
import { SummaryPannel } from '@/views/WorkPlace/Container/chat/components'

const prop = defineProps({
  // 病历编号
  serialNumber: {
    type: String,
    default: ''
  },
  // 病历编号
  id: {
    type: [String, Array],
    default: '0'
  },
  mode: {
    type: String,
    default: ''
  }
})
const emit = defineEmits(['jumpTo', 'noDetail'])
const determineRef = ref(null)
// 渲染基本信息 处方or辅助方
const columnsBase = ref([...BASE_LABEL])
// 渲染数据patientGender
const info = reactive({
  // 基本信息
  base: {},
  // 药品/商品信息
  drugs: [],
  // 订单信息
  orderInfo: [],
  // 售后信息
  postSaleVOS: [],
  // 活动
  activityInfoVO: [],
  // 判断随访新老数据
  visitPageType: null
})
// 商品信息 表格项（列）
const columns = ref(columnWesternMedicine)
const columnSale = ref(columnSaleWestern)
// 1 西药 2 中药
const recomType = ref(1)
const handleColumns = (type, agreement) => {
  const base = JSON.parse(JSON.stringify(BASE_LABEL))
  if (type === 1) {
    base.splice(3, 0, ...EN_Add_Label)
    return base
  } else {
    // 协定方
    if (agreement && agreement === 1) {
      base.splice(3, 0, ...AN_Add_Label)
    } else {
      // 西药
      base.splice(3, 0, ...CN_Add_Label)
    }
    return base
  }
}

watch(
  recomType,
  type => {
    switch (type) {
      case 1:
        columns.value = columnWesternMedicine
        columnSale.value = columnSaleWestern
        columnsBase.value = [...handleColumns(type), ...NEW_Label]
        break
      case 2:
        if (info.base.instanceBusinessType === 1) {
          // 协定方
          columns.value = agreementMedicine
          columnSale.value = columnSaleAgreement
          columnsBase.value = [...handleColumns(type, info.base.instanceBusinessType), ...NEW_Label]
        } else {
          // 中药
          columns.value = columnChineseMedicine
          columnSale.value = columnSaleChinese
          columnsBase.value = [...handleColumns(type), ...NEW_Label]
        }
        break
      default:
        columns.value = columnWesternMedicine
        columnSale.value = columnSaleWestern
        break
    }
  },
  { immediate: true }
)
/**
 * @description: 处方状态
 * @return {String} 0：未购， 1：已全部购买， 2：待支付，3 已作废 4:已取消
 */
//const imgStatus = ref(0)
const loading = ref(false)
// 总金额
const totalAmount = ref(0)
// 中药药品信息
const CNData = ref({})
// 处方详情
async function getDetail() {
  loading.value = true
  info.base = {}
  info.drugs.splice(0)
  info.activityInfoVO.splice(0)
  info.postSaleVOS.splice(0)
  info.orderInfo.splice(0)
  let result
  if (prop.serialNumber) {
    try {
      result = await PD_bySerialNumber(prop.serialNumber)
    } catch (err) {
      console.log(err)
      emit('noDetail', '', prop.serialNumber)
    }
  } else {
    try {
      result = await PD_byId(prop.id)
    } catch (err) {
      console.log(err)
      emit('noDetail', prop.id, '')
    }
  }
  const [tmp] = result
  recomType.value = tmp.recomType
  info.base = tmp
  info.base.patientGender = ['女', '男', '未知'][info.base.patientGender]
  /**
   * NOTE:判断状态 已失效状态特殊处理
   * 处方状态图 0：未购， 1：已全部购买， 2：待支付，3 已作废 4:已取消，5已删除 ，6已失效
   * 未购买如果超时就是失效，未超时就是未购买
   * 未购买优先展示作废，未作废就是未购买
   * 已经购买如果取消就是取消，未取消就是已经购买
   */
  // if (tmp.status === 0 && info.base.expire === 1) {
  //   imgStatus.value = 6
  // } else if (tmp.status === 0 && info.base.invalid === 1) {
  //   imgStatus.value = 7
  // } else {
  //   imgStatus.value = tmp.status
  // }
  // NOTE: 西药取 items, 中药取 medicineDetails
  if (recomType.value === 1) {
    info.drugs = tmp.items
  } else {
    // 协定方的药品数据
    if (info.base.instanceBusinessType === 1) {
      info.drugs = info.base.chinesePrescriptions || [
        {
          prescriptionName: info.base.prescriptionName,
          prescriptionAmount: info.base.prescriptionAmount,
          prescriptionSn: info.base.prescriptionSn
        }
      ]
    } else {
      const medicineDetails = tmp.medicineDetails
      info.drugs = medicineDetails.map(el => el)
    }
    const {
      dosageType,
      usage: resUsage,
      taboo,
      advice,
      pharmacyRemark,
      instanceBusinessType = 0
    } = tmp
    CNData.value = {
      dosageType,
      usage:
        instanceBusinessType === 1
          ? `${resUsage.mode}，${resUsage.takeMode}，${resUsage.takeTime}`
          : `${resUsage.mode}，${resUsage.postsNum}贴，${resUsage.takeMode}，${resUsage.takeTime}`,
      taboo,
      advice,
      pharmacyRemark,
      cycle: `${resUsage.cycle > 0 ? resUsage.cycle + resUsage.cycleUnit : '--'}`
    }
  }
  // 活动信息
  info.activityInfoVO = tmp.activityInfoVO ? [tmp.activityInfoVO] : []
  // 商品总额
  totalAmount.value = tmp.prescriptionAmount
  // 订单详情列表
  info.orderInfo = tmp.orderInfoVOS || []
  // 售后列表
  info.postSaleVOS = tmp.postSaleVOS || []
  loading.value = false
}

const activeKey = ref('2')
function jumpTo(is = 'visit', id) {
  if (info.visitPageType !== 1) {
    // 判断是否是新的数据
    emit('jumpTo', is, id)
  }
}

// 判定疗效
function doDetermine() {
  const { effectivenessResult, serialNumber } = info.base
  const params = {
    prescriptInfo: {
      operationType: effectivenessResult ? 1 : 0, //0-判定 1-修改判定,
      operationSource: effectivenessResult ? 0 : 1, //0 是修改，1是处方详情里面判断 ，2是工单里面判断
      serialNumber,
      originalSource: 6,
      effectivenessResult
    },
    mode: 1
  }
  determineRef.value.initModal(params)
}
const _normalizeField = e => {
  let content = ''
  // 嘱托改为原来的服用禁忌+医嘱
  if (e.value === 'taboo') {
    content = getEntrust(CNData.value['taboo'], CNData.value['advice'])
  } else {
    content = (CNData.value && CNData.value[e.value]) || '--'
  }

  return content
}
const summaryPanelVisible = ref(false)
const chatSummaryId = ref('')
// 待购工单AI语音优化 失效打开小结详情
const openSummaryPanel = () => {
  summaryPanelVisible.value = true
  chatSummaryId.value = info.base.chatSummaryId
}
onMounted(() => {
  getDetail()
  isPlanOrVisitMethods({ serialNumber: prop.serialNumber }, res => {
    if (res.dateFlg) {
      info.visitPageType = res.dateFlg ? 1 : 2
    }
  })
})
</script>
<template>
  <div class="detail">
    <a-spin :spinning="loading">
      <div class="head">
        <h3 class="head-left">基本信息</h3>
        <div class="head-right">
          <!-- 待购工单AI语音优化 失效打开小结详情 -->
          <a-button
            size="small"
            v-if="!!info.base.chatSummaryId"
            @click="openSummaryPanel"
            type="primary"
            ghost
          >
            未购原因
          </a-button>
          <span class="head-right_id">处方ID: {{ info.base.serialNumber }}</span>
          <span>开方时间: {{ info.base.createdAt }}</span>
        </div>
      </div>
      <!-- 病历信息 -->
      <ul class="detail_info">
        <auth-img
          class="detail_info-status"
          :src="getStatusImg(info.base)?.src"
          :alt="getStatusImg(info.base)?.alt"
        />
        <li
          class="detail_info-item"
          v-for="column in columnsBase"
          :class="column.class"
          :key="column.prop"
        >
          <label class="item_label">{{ column.label }}</label>
          <!-- 诊断 -->
          <template
            v-if="['westernDiagnosisInfoList', 'chieseDiagnosisInfoList'].includes(column.prop)"
          >
            <template v-if="info.base.instanceBusinessType === 1">
              <!-- 协定方：诊断+中医证型 -->
              <span
                v-if="['westernDiagnosisInfoList', 'chieseDiagnosisInfoList'].includes(column.prop)"
                class="item_content"
              >
                {{ newCalcDiagnosis(info.base, column.prop) }}
              </span>
            </template>
            <!-- 西药只有诊断 -->
            <template v-else-if="recomType === 1">
              <span v-if="['westernDiagnosisInfoList'].includes(column.prop)" class="item_content">
                {{ newCalcDiagnosis(info.base, column.prop) }}
              </span>
            </template>
            <!-- 中药只有中医证型 -->
            <template v-else-if="recomType === 2">
              <span v-if="['chieseDiagnosisInfoList'].includes(column.prop)" class="item_content">
                {{ newCalcDiagnosis(info.base, column.prop) }}
              </span>
            </template>
          </template>
          <!-- 随访计划 -->
          <span v-else-if="column.prop === 'followupPlanIds'" class="item_content">
            <template v-if="info.base.followupPlanIds && info.base.followupPlanIds.length">
              <span
                :class="[info.visitPageType !== 1 ? 'link_content' : '']"
                v-for="(it, index) in info.base.followupPlanIds"
                :key="it"
                @click="jumpTo('visit', it)"
              >
                {{ it }}
                <span v-if="info.base.followupPlanIds.length !== index + 1">,</span>
              </span>
            </template>
            <span v-else>--</span>
          </span>
          <span v-else-if="column.prop === 'patientAge'" class="item_content">
            {{ info.base.patientAge + ' ' + (info.base.patientAgeUnit || '岁') }}
          </span>
          <span v-else-if="column.prop === 'taboo'" class="item_content">
            {{ getEntrust(info.base.taboo, info.base.advice) }}
          </span>
          <!-- 治疗状态 -->
          <span v-else-if="column.prop === 'effectivenessResult'" class="item_content">
            {{ handleCureStatus(info.base[column.prop]) }}
            <span
              class="determine"
              @click="doDetermine"
              v-if="!mode && info.base.effectivenessResult !== -1"
            >
              {{ info.base[column.prop] ? '修改' : '判定' }}
            </span>
          </span>
          <!-- 判定人 -->
          <span v-else-if="column.prop === 'assertCureName'" class="item_content">
            {{ handleAssertCureName(info.base[column.prop]) }}
          </span>
          <span v-else-if="column.prop === 'assertCureTime'" class="item_content">
            {{ momentFormat(info.base.assertCureTime, 'YYYY-MM-DD HH:mm:ss') }}
          </span>
          <span v-else class="item_content">
            {{ info.base[column.prop] || '--' }}
          </span>
        </li>
      </ul>
      <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane key="2" tab="订单信息">
          <a-table
            class="order-info"
            :transformCellText="({ text }) => text ?? '--'"
            :rowKey="(record, index) => index"
            :pagination="false"
            :dataSource="info.orderInfo"
            :columns="columnOrder"
            :scroll="{ y: 360, x: '100%' }"
          >
            <template #reviewContent="text">
              <a-popover
                placement="topLeft"
                :overlayStyle="{ width: '310px' }"
                v-if="text.record.reviewContent"
                class="order-info-tooltip"
              >
                <template #content>
                  <span class="comment-body">{{ text.record.reviewContent }}</span>
                </template>
                <span class="comment">{{ text.record.reviewContent }}</span>
              </a-popover>
              <span v-else>--</span>
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="1" tab="药品信息">
          <a-table
            bordered
            :transformCellText="({ text }) => (text ? text : '--')"
            :rowKey="(record, index) => index"
            :pagination="false"
            :dataSource="info.drugs"
            :columns="columns"
          >
            <template #drugCycle="{ text, record }">
              <span>{{ text }}{{ record.drugCycleUnit }}</span>
            </template>
          </a-table>
          <div class="CNInfo" v-if="recomType === 2">
            <div
              class="infoItem"
              v-for="(e, i) in info.base.instanceBusinessType === 1
                ? AGREEMENT_DRUG_ADD
                : CHINESE_DRUG_ADD"
              :key="i"
            >
              <span>{{ e.value === 'taboo' ? getTitle(info.base.usage) : e.label }}：</span>
              <!-- <span>{{ (CNData && CNData[e.value]) || '--' }}</span> -->
              <span>{{ _normalizeField(e) }}</span>
            </div>
          </div>
          <h3 class="total">总金额：{{ totalAmount }}元</h3>
        </a-tab-pane>
        <a-tab-pane key="3" tab="售后信息">
          <a-table
            :transformCellText="({ text }) => text ?? '--'"
            :rowKey="(record, index) => index"
            :pagination="false"
            :dataSource="info.postSaleVOS"
            :columns="columnSale"
            :scroll="{ y: 360, x: '100%' }"
          />
        </a-tab-pane>
        <a-tab-pane key="0" tab="活动信息">
          <a-table
            :transformCellText="({ text }) => text ?? '--'"
            :rowKey="(record, index) => index"
            :pagination="false"
            :dataSource="info.activityInfoVO"
            :columns="columnActive"
            :scroll="{ y: 360, x: '100%' }"
          />
        </a-tab-pane>
      </a-tabs>
    </a-spin>
    <DetermineEffect ref="determineRef" @completeBuss="getDetail" />
    <!-- <determineCure
      v-model:visible="visible"
      :recommendId="info.base.recommendId"
      :serialNumber="info.base.serialNumber"
      :currentStatus="info.base.cureStatus"
      @handleDetermine="handleDetermine"
      :prescriptionType="0"
    /> -->
    <!-- 沟通小结 -->
    <a-modal
      title="沟通小结"
      :visible="summaryPanelVisible"
      @cancel="summaryPanelVisible = false"
      width="1059px"
      :footer="null"
      :destroyOnClose="true"
      :bodyStyle="{
        padding: 0,
        paddingTop: '20px'
      }"
    >
      <SummaryPannel
        :chatSummaryId="chatSummaryId"
        @closeSummaryModal="summaryPanelVisible = false"
      />
    </a-modal>
  </div>
</template>
<style lang="scss" scoped>
.link_content {
  color: #1890ff;
}
.head {
  display: flex;
  justify-content: space-between;

  .head-left {
    font-weight: bold;
    font-size: 16px;
    color: #333333;
  }

  .head-right {
    color: #999;
    font-size: 14px;
    font-weight: 400;

    &_id {
      margin: 0 32px;
    }
  }
}

.detail_info {
  display: grid;
  grid-template-columns: repeat(3, 33.33%);
  grid-template-rows: repeat(2, minmax(44px, auto));
  list-style: none;
  margin: 0;
  padding-left: 0;
  grid-gap: 5px 0;
  position: relative;
  margin-bottom: 30px;

  &-status {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 1;
    transform: translateY(-30px);
    width: 120px;
  }

  &-item {
    padding: 20px 0 20px 16px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e8e8e8;

    // 第一列左对齐
    &:nth-child(2),
    &:nth-child(5),
    &:nth-child(8),
    &:nth-child(11) {
      padding-left: 0;
    }

    .item_label {
      flex-shrink: 0;
      margin-right: 3px;
      color: #999999;
    }

    .item_content {
      flex: auto;
      width: 80%;
      position: relative;
      z-index: 2;
      font-weight: bold;

      &:after {
        content: '';
        display: block;
        width: 1px;
        background: #e8e8e8;
        position: absolute;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .determine {
      padding: 2px 8px;
      background: #1890ff;
      border-radius: 4px;
      border-radius: 2px;
      font-weight: 400;
      font-size: 12px;
      color: #ffffff;
      cursor: pointer;
    }
    // 最后一列去掉灰色的竖线
    &:nth-child(4) .item_content:after,
    &:nth-child(7) .item_content:after,
    &:nth-child(10) .item_content:after {
      background-color: transparent;
    }
  }

  // 网格布局大
  .big {
    grid-column-start: 2;
    grid-column-end: 4;
  }

  // 网格布局 巨大
  .large {
    grid-column-start: 1;
    grid-column-end: 4;
  }
}
.CNInfo {
  display: flex;
  flex-wrap: wrap;
  border: 1px solid #f0f0f0;
  border-top: none;
  border-radius: 0 0 4px 4px;
  padding: 20px 16px 0px;
  .infoItem {
    width: 50%;
    margin-bottom: 20px;

    span:nth-of-type(1) {
      font-weight: 550;
      color: #333333;
    }
    span:nth-of-type(2) {
      font-weight: 400;
      color: #666666;
    }
  }
}
.order-info-tooltip {
  width: 300px;
}
.comment-body {
  color: black;
}

// 底部药品信息
.total {
  margin-top: 10px;
  text-align: right;
}
</style>
